"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var availability_const_1 = require("./availability.const");
/**
 * AvailabilityService
 * @class
 */
var AvailabilityService = /** @class */ (function () {
    function AvailabilityService() {
    }
    /**
     * Returns an availability of vehicles for a given profile (`userProfileUuid`),
     * in a given city (`cityUuid`) and between given dates: `start` and `end`
     * @param userProfileUuid {string}
     * @param cityUuid {string}
     * @param bookingType {BookingType}
     * @param start {string}
     * @param end {string}
     * @returns
     */
    AvailabilityService.prototype.getAvailability = function (userProfileUuid, cityUuid, bookingType, from, to, version) {
        if (version === void 0) { version = 'v1'; }
        var url = availability_const_1.AVAILABILITY_ENDPOINT.getAvailability
            .replace('{{version}}', version)
            .replace('{{userProfileUuid}}', userProfileUuid)
            .replace('{{cityUuid}}', cityUuid)
            .replace('{{bookingType}}', bookingType)
            .replace('{{start}}', from)
            .replace('{{end}}', to);
        return axios_client_service_1.axiosClientInstance.post(url);
    };
    return AvailabilityService;
}());
/**
 * External AvailabilityService Class Instance
 * @namespace
 */
exports.availability = new AvailabilityService();
